import { useSelector } from 'react-redux';
import { TRIAL_MODAL_SETTINGS } from 'constants/trial';
import WaitCard from 'ui-component/cards/WaitCard';
import { BarChartRounded } from '@mui/icons-material';
import PlanRestriction from 'ui-component/PlanRestriction';

const DisableTrialPlanPermissions = ({ children, trialContent = null, fullPage = false }) => {
    const { clientSettings, clientSettingsStatus } = useSelector((state) => state.settings);

    const isTrial = clientSettings?.trial === true || clientSettings?.subscription?.subscriptionPackage === 'TRIAL';
    const isReady = clientSettingsStatus === 'succeeded';
    if (!trialContent)
        trialContent = {
            title: 'Access Not Allowed',
            description: ' Upgrade to a paid plan to access full RPL Robot features.'
        };

    // add the modal default settings
    trialContent = {
        ...trialContent,
        ...TRIAL_MODAL_SETTINGS
    };
    
    if (!isReady) return <WaitCard />;
    if (isReady && isTrial) return <PlanRestriction {...trialContent} icon={<BarChartRounded />} fullPage={fullPage} />;
    return <>{children}</>;
};

export default DisableTrialPlanPermissions;
